import { Flex, Tag } from "@chakra-ui/react";
import * as AF from "src/types/formTemplate";

interface QuestionTagProps {
  question: AF.V3.Question;
  section?: AF.V3.Section;
}

interface SectionTagProps {
  question?: AF.V3.Question;
  section: AF.V3.Section;
}

type Props = QuestionTagProps | SectionTagProps;

export const InternalOnlyTag: React.FC<Props> = ({ question, section }) => {
  if (
    question &&
    (question.permissionLevel === undefined ||
      question.permissionLevel === null ||
      question.permissionLevel.trim() === "")
  ) {
    return null;
  }

  if (section && !section.permissionLevel) {
    return null;
  }

  return (
    <Flex direction="row">
      <Tag size="sm">Internal-Only</Tag>
    </Flex>
  );
};

export function hasInternalOnlyTag(question: AF.V3.Question): boolean {
  return InternalOnlyTag({ question }) !== null;
}
